<template>
  <div>
    <BookDirectAboutUs v-if="$siteConfig.brand ==='BookDirect'" />
  </div>
</template>

<script setup lang="ts">
const { $siteConfig } = useNuxtApp()
import BookDirectAboutUs from "~/components/Documents/BookDirectAboutUs.vue";
import { useRouter } from "vue-router";
const router = useRouter();
onMounted(() => {
  if ($siteConfig.value?.brand !=='BookDirect') {
    router.push({ path: "/" });
  }
})
</script>
